import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row, Table } from 'reactstrap';
import { ProjectCheckpointsList } from '../../../../domain/projectCheckpoints/projectCheckpointList';
import { ProjectCheckpointsRepository } from '../../../../infrastructure/repositories/projectCheckpoints/projectCheckpointsRepository';
import { Private_Routes } from '../../../../main/constants';
import { AppContext } from '../../../../main/context/Provider';
import { AddButton } from '../../../shared/components/AddButton';
import TaskStatusSelector from '../selectors/TaskStatusSelector';

interface ProjectCheckpointSectionProps {
    projectCheckpoints: ProjectCheckpointsList[] | undefined;
    projectId: string | undefined;
}

const ProjectCheckpointSection = ({
    projectCheckpoints,
    projectId,
}: ProjectCheckpointSectionProps) => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);
    const [expandedTasks, setExpandedTasks] = useState<Record<number, boolean>>({});
    const [projectCheckpointsState, setProjectCheckpointsState] = useState<
        ProjectCheckpointsList[] | undefined
    >();

    const toggleTasks = (id: number) => {
        setExpandedTasks((prevExpanded) => ({
            ...prevExpanded,
            [id]: !prevExpanded[id],
        }));
    };

    useEffect(() => {
        setNestedRoutes([
            {
                label: 'Proyectos',
                route: Private_Routes.PROJECT_PAGE,
            },
            {
                label: 'Seguimientos',
                route: Private_Routes.PROJECT_CHECKPOINTS_PAGE,
            },
        ]);
    }, [lang]);

    const handleStatusChange = (taskId: number, newStatus: string) => {
        const statusRequest = { status: parseInt(newStatus) };
        ProjectCheckpointsRepository.UpdateTaskStatus(taskId, statusRequest)
            .then((response) => {
                setProjectCheckpointsState((prevCheckpoints) => {
                    const updatedCheckpoints = prevCheckpoints
                        ? [...prevCheckpoints]
                        : [];
                    const updatedTaskIndex = updatedCheckpoints.findIndex(
                        (checkpoint) => checkpoint.id === taskId
                    );
                    if (updatedTaskIndex !== -1) {
                        updatedCheckpoints[updatedTaskIndex] = {
                            ...updatedCheckpoints[updatedTaskIndex],
                        };
                    }

                    return updatedCheckpoints;
                });
            })
            .catch((error) => {
                // Manejo de errores
            });
    };

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <div className='row p-2'>
                        <div className='col-10 d-flex justify-content-start p-1'>
                            <h5 className='card-title flex-grow-1'>
                                Registro de Seguimientos
                            </h5>
                        </div>
                        <div className='col-2 d-flex justify-content-end align-items-center mb-3'>
                            <AddButton
                                href={`/project-checkpoints/create/${projectId}`}
                            />
                        </div>
                    </div>
                    <Row>
                        <Col lg={12}>
                            <div className='table-responsive table-card'>
                                <Table className='table-borderless align-middle mb-0'>
                                    <thead className='table-light'>
                                        <tr>
                                            <th scope='col'>Responsable</th>
                                            <th scope='col'>Fecha De Creación</th>
                                            <th scope='col'>Detalles</th>
                                            <th scope='col'>Ver Tareas</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {projectCheckpoints?.map(
                                            (projectCheckpoint) => (
                                                <React.Fragment
                                                    key={projectCheckpoint?.id}
                                                >
                                                    <tr>
                                                        <td>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='avatar-sm'>
                                                                    <div className='avatar-title bg-light text-primary rounded fs-24'>
                                                                        <i className='ri-user-2-fill'></i>
                                                                    </div>
                                                                </div>
                                                                <div className='ms-3 flex-grow-1'>
                                                                    <h5 className='fs-13 mb-0'>
                                                                        <Link
                                                                            to='#'
                                                                            className='text-dark'
                                                                        >
                                                                            {
                                                                                projectCheckpoint.employeeName
                                                                            }
                                                                        </Link>
                                                                    </h5>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {projectCheckpoint?.date
                                                                ? new Date(
                                                                      projectCheckpoint.date
                                                                  ).toLocaleDateString()
                                                                : ''}
                                                        </td>
                                                        <td>
                                                            {
                                                                projectCheckpoint.comments
                                                            }
                                                        </td>
                                                        <td>
                                                            <button
                                                                className='btn btn-sm btn-icon'
                                                                onClick={() =>
                                                                    toggleTasks(
                                                                        projectCheckpoint.id
                                                                    )
                                                                }
                                                            >
                                                                {expandedTasks[
                                                                    projectCheckpoint
                                                                        .id
                                                                ] ? (
                                                                    <i className='ri-arrow-down-s-line'></i>
                                                                ) : (
                                                                    <i className='ri-arrow-up-s-line'></i>
                                                                )}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    {expandedTasks[
                                                        projectCheckpoint.id
                                                    ] && (
                                                        <tr>
                                                            <td
                                                                colSpan={5}
                                                                className='px-5'
                                                            >
                                                                <table className='table table-hover'>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>
                                                                                Tarea
                                                                            </th>
                                                                            <th>
                                                                                Consultor
                                                                            </th>
                                                                            <th>
                                                                                Fecha
                                                                                Estimada
                                                                            </th>
                                                                            <th></th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className='table-group-divider'>
                                                                        {projectCheckpoint.tasks.map(
                                                                            (
                                                                                task
                                                                            ) => (
                                                                                <tr
                                                                                    key={
                                                                                        task.id
                                                                                    }
                                                                                >
                                                                                    <td>
                                                                                        {
                                                                                            task.task
                                                                                        }
                                                                                    </td>
                                                                                    <td>
                                                                                        {
                                                                                            task.consultant
                                                                                        }
                                                                                    </td>
                                                                                    <td>
                                                                                        {task?.estimatedDate
                                                                                            ? new Date(
                                                                                                  task.estimatedDate
                                                                                              ).toLocaleDateString()
                                                                                            : ''}
                                                                                    </td>
                                                                                    <td>
                                                                                        <TaskStatusSelector
                                                                                            status={
                                                                                                task.status
                                                                                            }
                                                                                            onChange={(
                                                                                                value
                                                                                            ) =>
                                                                                                handleStatusChange(
                                                                                                    task.id,
                                                                                                    value
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default ProjectCheckpointSection;
